import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

const AmountField = ({ label, source, record = {} }) => (
	<span>
		{get(record, source + '.amount')} {get(record, source + '.currency')}
	</span>
);

AmountField.propTypes = {
	label: PropTypes.string,
	record: PropTypes.object,
	source: PropTypes.string.isRequired
};

AmountField.defaultProps = {
	addLabel: true
};

export default AmountField;
